import No from "../No";

export const getPageMath3WorkingsNotes = (page, edition) => {
  let EditionPageContent;
  let editable = true;
  switch (page) {
    case 1:
    case 2:
    case 3:
    case 4:
      editable = false;
      EditionPageContent = No;
      break;
    default:
      EditionPageContent = No;
      break;
  }
  return {
    editable,
    component: EditionPageContent,
    addProps: {}
  };
}